import http from '@axios'
import {getUserToken, getUserData} from "@/helpers/Utils";

const endpoint = `/permit`;

const body = {
  "req": {
    "id": 123342523,
    "time": "2021-08-09T10:11:20+07:00",
    "src": "member-web",
    "op": "addPermit"
  },
  "data": {}
};

const addPermit = (data) => {
  let defaultData = {
    lic_plate: "",
    // container: "",
//    containers: [
//      { container: 'container pertama' },
//      { container: 'container kedua' },
//    ],
    permit_date: "",
    direction: 1,  // 1=in 2=out
    cond: 1,  // 1=kosong 2=isi
    user_id: 1,                 // member user_id
    user_name: "abdul hamid",  // member user
    pass_total: 1, // container always 1
    pass_seq: 1,  // container always 1
    pass_qty: 1,  // container always 1
    aprv_id: 0,  // optional
    aprv_name: "",  // approver name, optional = empty
    aprv_note: "",  // approver note, optional = empty
    aprv_time: "", // approve time optional = request time
    driver_id: 0, // optional, always 0, reserved for future function
    driver_name: "", // optional, always empty string, reserved for future function
  }
  const user = getUserData();
  body.req.op = 'addPermit';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = { ...defaultData, ...data};
  return http.post(endpoint, body);
}

const listPermit = (data) => {
  const user = getUserData();
  body.req.op = 'listPermit';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}

const listPermitByVehicle = (data) => {
  const user = getUserData();
  body.req.op = 'listPermitByVehicle';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}

const setPermitStatus = (data) => {
  const user = getUserData();
  body.req.op = 'setPermitStatus';
  body.req.uid = user.id;
  body.req.uname = user.username;
  body.req.token = getUserToken();
  body.data = data;
  return http.post(endpoint, body);
}
export { listPermit, addPermit, listPermitByVehicle, setPermitStatus }
